const HeaderSection = ({
  classNameContainer,
  classNameTitle,
  disableBoxModel = false,
  children,
}) => {
  return (
    <div className={`${classNameContainer}`}>
      <div
        className={`${
          disableBoxModel ? "pb-3 mx-3" : ""
        } font-bold md:text-4xl text-2xl text-primary ${classNameTitle}`}
      >
        {children.charAt(0).toUpperCase() + children.slice(1)}
        <span className="text-green-600">_</span>
      </div>
    </div>
  );
};

export default HeaderSection;
